import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IOfferOcrChallenge } from '@/shared/model/offer-ocr-challenge.model';
import { IOfferOcrChallengeRollback } from './../../shared/model/offer-ocr-challenge-rollback.model';
import { rejects } from 'assert';

const baseApiUrl = 'api/offer-ocr-challenges';
const baseSearchApiUrl = 'api/_search/offer-ocr-challenges?query=';
const baseSerachApiTrans = 'api/_search/offer-ocr-challenge?txnId=';
const baseAPIGetLocation = 'api/_search/merchant-locations/merchantId';
const baseRollbackApiUrl = 'api/offer_ocr_challenge_rollback';

export default class OfferOcrChallengeService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IOfferOcrChallenge> {
    return new Promise<IOfferOcrChallenge>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios
        .get(
          baseApiUrl +
            '?offerId=&userId=&state=&offerType=&startDateOfUpload=&endDateOfUpload=' +
            `&${buildPaginationQueryOpts(paginationQuery)}`
        )
        .then(function(res) {
          resolve(res);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IOfferOcrChallenge): Promise<IOfferOcrChallenge> {
    return new Promise<IOfferOcrChallenge>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IOfferOcrChallenge): Promise<IOfferOcrChallenge> {
    return new Promise<IOfferOcrChallenge>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public searchTransaction(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSerachApiTrans}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public getLocations(id: number, storeName): Promise<any> {
    return new Promise<IOfferOcrChallenge>(resolve => {
      axios.get(`${baseAPIGetLocation}/${id}?search=${storeName}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  // Send Mail
  public sendMail(entity): Promise<any> {
    return new Promise<IOfferOcrChallenge>(resolve => {
      axios.post(`${baseApiUrl}/customer-support`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  // Initiate Rollback
  public initiateRollback(entity: IOfferOcrChallengeRollback): Promise<IOfferOcrChallengeRollback> {
    return new Promise<IOfferOcrChallengeRollback>((resolve, reject) => {
      axios
        .post(`${baseRollbackApiUrl}/initiate`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  // Initiate Rollback
  public approveRollback(entity: IOfferOcrChallengeRollback): Promise<IOfferOcrChallengeRollback> {
    return new Promise<IOfferOcrChallengeRollback>((resolve, reject) => {
      axios
        .post(`${baseRollbackApiUrl}/approve`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}
